module.exports = __webpack_public_path__ + "static/media/red-shoes.b74e32d3.png";